import { render, staticRenderFns } from "./OfferTotalsSection.vue?vue&type=template&id=6fba1ef0&scoped=true"
import script from "./OfferTotalsSection.vue?vue&type=script&lang=js"
export * from "./OfferTotalsSection.vue?vue&type=script&lang=js"
import style0 from "./OfferTotalsSection.vue?vue&type=style&index=0&id=6fba1ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba1ef0",
  null
  
)

export default component.exports